export default "/_next/static/images/shopify-77a5625afbde62f2e7de0404cd421166.svg";